import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const contrastSecurity = defineConnector({
  identifier: "contrastSecurity",
  name: "Contrast Security",
  tagLine: "Application security testing",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://app.contrastsecurity.com/Contrast/api"),
  auth: headerAuth([
    { name: "API-Key", value: { from: "secret", field: "apiKey" } },
    {
      name: "Authorization",
      value: { from: "secret", field: "authorization" },
    },
    { name: "Accept", value: { from: "literal", value: "application/json" } },
  ]),
  steps: [
    {
      title: "Set up Contrast Security",
      items: [
        {
          kind: "markdown",
          content:
            "In Contrast, open **User menu → User settings → Profile → Your keys**. Copy the **API key** and **Authorization header**. Select **Generate sample API request** to confirm your server URL. The connection test reads your user profile. See [View your API keys](https://docs.contrastsecurity.com/en/personal-keys.html).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://app.contrastsecurity.com/Contrast/api",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "In Contrast’s API keys panel, select **Generate sample API request** to find your server URL. Include the /Contrast/api path, for example https://app.contrastsecurity.com/Contrast/api.",
        },
        {
          kind: "input",
          label: "API Key",
          required: true,
          target: {
            kind: "secrets",
            field: "apiKey",
          },
          helperText:
            "Contrast API Key copied from User settings → Profile → Your keys → Your API Keys.",
        },
        {
          kind: "input",
          label: "Authorization header",
          required: true,
          target: {
            kind: "secrets",
            field: "authorization",
          },
          helperText:
            "Copy the authorization header shown in Contrast’s API keys panel.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://app.contrastsecurity.com/Contrast/api")
          .trim()
          .replace(/\/+$/, "") + "/ng/profile",
      ...{ method: "GET", headers: { Accept: "application/json" } },
    }),
  },
});
